// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"71":"102ef24b","719":"b700949e"}[chunkId] + ".chunk.css";
};